import React from 'react';
import autobind from 'autobind-decorator';
import {Table} from 'react-bootstrap';

import {
    ArrayUtils
} from "../../Utils";
import {
    Conditional
} from "../Conditional";
import {
    HelpIcon
} from "./HelpIcon";
import {NoModeledUpliftWarning} from "./NoModeledUpliftWarning";

export class ContextNodeBenefitSummary extends React.PureComponent {

    @autobind
    renderAcres(value) {
        let formattedValue = "0.0";
        if(value) {
            formattedValue = value.toFixed(1);
        }

        return <span>{formattedValue} ac.</span>;
    }

    @autobind
    renderTitleRow(includeHeaderColumn) {
        const { confirmationStatuses, headerColumnTitle } = this.props;

        return <tr key="header">
            <Conditional Condition={ includeHeaderColumn }>
                <th> { headerColumnTitle } </th>
            </Conditional>
            {
                confirmationStatuses.map( (confirmationStatus) => {
                    return <th className="sb-benefit-summary-header"  key={confirmationStatus.confirmationStatusId}>
                        {confirmationStatus.name}
                        <Conditional Condition={confirmationStatus.code=="pre-confirmation"}>
                            <HelpIcon backgroundColor="#FEFEFE">
                                For Conservation Actions without As-Built data this column will include Eligibility or Design data.
                            </HelpIcon>
                        </Conditional>
                    </th>
                })
            }
        </tr>;
    }

    @autobind
    renderRow(data, includeHeader) {
        const { confirmationStatuses } = this.props;
        const title = data.shortName || data.name;
        const numberFormatter = new Intl.NumberFormat();

        return <tr className={data.isTotal ? "total" : ""} key={data.contextNodeId}>
            <Conditional Condition={includeHeader}>
                <th title={title}><span>{data.name}</span></th>
            </Conditional>
            <Conditional Condition={data.hasData} key='has'>
                {
                    confirmationStatuses.map((confirmationStatus) => {
                        const value = data.benefitValue[confirmationStatus.confirmationStatusId];
                        const formattedValue = value != null ? numberFormatter.format(value) : "";

                        return <td key={confirmationStatus.confirmationStatusId}>
                            {formattedValue} {data.unitAbbreviation}
                        </td>
                    })
                }
            </Conditional>
            <Conditional Condition={!data.hasData} key='has-not'>
                <td colSpan={confirmationStatuses.length}>
                    <NoModeledUpliftWarning/>
                </td>
            </Conditional>
        </tr>;
    }

    translateBenefitSummaryToRowData(benefitSummary, environmentalBenefitId) {

        const { confirmationStatuses, parentContextNodeId } = this.props;

        if(!benefitSummary) {
            return [];
        }

        const filteredBenefitSummary = benefitSummary
            .filter((contextNode) => contextNode.environmentalBenefitId == environmentalBenefitId );

        const rowData = filteredBenefitSummary.reduce(function(accumulator, contextNode) {

            const contextNodeId = contextNode.contextNodeId;

            let target = accumulator[contextNodeId] ?? (accumulator[contextNodeId] = {
                parentContextNodeId: contextNode.parentContextNodeId,
                contextNodeId: contextNode.contextNodeId,
                name: contextNode.name,
                shortName: contextNode.shortName,
                link: contextNode.link,
                unitAbbreviation: contextNode.unitAbbreviation,
                benefitValue: {},
                isTotal: false,
                hasData: false,
            });

            if(contextNode.contextNodeId == parentContextNodeId) {
                target.isTotal = filteredBenefitSummary.length > 1; // only treat it as a
                target.name = target.shortName = 'Total';
                target.link = null;
            }

            for(const confirmationStatus of confirmationStatuses) {
                // set defaults for all confirmationStatuses = 0
                if(target.benefitValue[confirmationStatus.confirmationStatusId] == undefined) {
                    target.benefitValue[confirmationStatus.confirmationStatusId] = 0;
                }

                if(contextNode.confirmationStatusId == confirmationStatus.confirmationStatusId) {
                    target.benefitValue[confirmationStatus.confirmationStatusId] = contextNode.benefitValue;
                    target.hasData = true;
                }
            }

            return accumulator;

        }, {});

        return Object.values(rowData).sort(ArrayUtils.SortToBottom((x) => x?.contextNodeId == parentContextNodeId));

    }

    render() {
        const { benefitSummary, environmentalBenefitId, confirmationStatuses } = this.props;

        const rowData = this.translateBenefitSummaryToRowData(benefitSummary, environmentalBenefitId);
        const includeHeaderColumn = rowData.length > 1;

        return  <Table className={"sb-benefit-summary-table environmentalBenefitId-" + environmentalBenefitId} bordered striped size="sm">
                    <thead>
                        { this.renderTitleRow(includeHeaderColumn) }
                    </thead>
                    <tbody>
                        <Conditional Condition={rowData.length > 0} key="data">
                            {
                                rowData?.map((row) => this.renderRow(row, includeHeaderColumn))
                            }
                        </Conditional>
                        <Conditional Condition={rowData.length == 0} key="no-data">
                            <tr>
                                <td colSpan={confirmationStatuses.length+1}>
                                    <Conditional Condition={benefitSummary != null}>
                                        <NoModeledUpliftWarning/>
                                    </Conditional>
                                    <Conditional Condition={benefitSummary == null}>
                                        <div className="sb-no-items-warning">
                                            Loading...
                                        </div>
                                    </Conditional>
                                </td>
                            </tr>
                        </Conditional>
                    </tbody>
                    <tfoot><tr><td className="sb-benefit-summary-table-footnote" colSpan={confirmationStatuses.length+1}></td></tr></tfoot>
                </Table>;
    }
}


